import type { DecadeWithMatched } from '@/hooks/useDashboardData'

interface DecadeChartProps {
  decades: DecadeWithMatched[]
}

export function DecadeChart({ decades }: DecadeChartProps) {
  if (decades.length === 0) return null

  const maxCnt = Math.max(...decades.map((d) => d.cnt))

  return (
    <div>
      <div className="flex items-end gap-1 sm:gap-2" role="img" aria-label="Concerts by decade">
        {decades.map((d) => {
          const totalHeight = Math.max(4, (d.cnt / maxCnt) * 120)
          const matchedHeight = d.cnt > 0 ? (d.matched / maxCnt) * 120 : 0

          return (
            <div key={d.decade} className="flex flex-1 flex-col items-center gap-1">
              <span className="text-xs text-muted-foreground">{d.cnt}</span>
              <div className="relative w-full" style={{ height: `${totalHeight}px` }}>
                <div className="absolute inset-0 rounded-t bg-secondary" />
                {matchedHeight > 0 && (
                  <div
                    className="absolute bottom-0 left-0 right-0 rounded-t bg-[hsl(var(--conf-high))]"
                    style={{ height: `${matchedHeight}px` }}
                    title={`${d.matched} fully matched`}
                  />
                )}
              </div>
              <span className="text-xs text-muted-foreground">{d.decade}s</span>
            </div>
          )
        })}
      </div>
      <div className="mt-3 flex items-center justify-center gap-4 text-xs text-muted-foreground">
        <span className="flex items-center gap-1.5">
          <span className="inline-block h-3 w-3 rounded-sm bg-secondary" />
          Total
        </span>
        <span className="flex items-center gap-1.5">
          <span className="inline-block h-3 w-3 rounded-sm bg-[hsl(var(--conf-high))]" />
          Fully matched
        </span>
      </div>
    </div>
  )
}
